// TEMPORÁRIO — mock local, remover no desenvolvimento do backend.
/**
 * Dado de leitura da Auditoria Financeira, resolvido a partir de
 * `dados-simulados.json`.
 *
 * NENHUMA DATA LITERAL. O JSON guarda a distância em meses até hoje
 * (`mesesAtras`) e, dentro do mês, só o dia e a hora do evento. A competência
 * de cada payload vira `mesReferencia` (`AAAA-MM`) aqui. Cada evento continua
 * registrado no mês seguinte ao da competência que ele cita, como o mock sempre
 * mostrou. Ano-mês escrito à mão envelhece sozinho (CLAUDE.md, "Nenhuma
 * competência literal no mock"); `dadosSimulados.spec.ts` falha se alguém
 * escrever um no JSON.
 */

import {
  anoMesAtras,
  dataAtras,
  instanteAtras,
  type DiaRelativo,
  type InstanteRelativo,
} from '../datasRelativas';
import DADOS_SIMULADOS from './dados-simulados.json';

interface EventoBruto {
  id: string;
  sequencia: number;
  registradoEm: InstanteRelativo;
  evento: string;
  categoria: string;
  ator: string | null;
  entidadeTipo: string;
  entidadeId: string;
  hashAnterior: string | null;
  hashAtual: string;
  payload: Record<string, unknown>;
}

interface Kpis {
  totalEventos: number;
  ultimas24h: number;
  atoresUnicos: number;
  categorias: number;
  tiposEvento: number;
}

interface DadosBrutos {
  kpis: Kpis;
  eventos: EventoBruto[];
}

function resolverPayload(payload: Record<string, unknown>, hoje: Date): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(payload).map(([chave, valor]) => {
      if (chave === 'mesReferenciaAtras') {
        return ['mesReferencia', anoMesAtras(valor as number, hoje)];
      }
      if (chave === 'novoPrazo') return [chave, dataAtras(valor as DiaRelativo, hoje)];
      return [chave, valor];
    }),
  );
}

export function carregarAuditoria(hoje = new Date()) {
  const bruto = DADOS_SIMULADOS as DadosBrutos;
  return {
    kpis: bruto.kpis,
    eventos: bruto.eventos.map((evento) => ({
      ...evento,
      registradoEm: instanteAtras(evento.registradoEm, hoje),
      payload: resolverPayload(evento.payload, hoje),
    })),
  };
}

export const DADOS_AUDITORIA = carregarAuditoria();
